module.exports = __webpack_public_path__ + "509e9484c0d888b7ae23f6f902f1690a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-1.png
// module id = 2181
// module chunks = 0